module.exports = __webpack_public_path__ + "static/img/RASM800_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASM800_1.png
// module id = i90C
// module chunks = 0